const icon = require('vue-svgicon');
icon.register({
    'lens-forms': {
        width: 52,
        height: 48,
        viewBox: '0 0 52 48',
        data: `<path pid="0" _stroke="#000" stroke-width="1.2" d="M.6 6.6h28.8v34.8H.6z"/><path pid="1" d="M32.156 41.4h-16.28c6.534-4.925 9.867-11.128 9.867-17.4 0-6.272-3.333-12.476-9.866-17.4h16.28C34.302 10.98 35.4 17.461 35.4 24c0 6.539-1.097 13.02-3.244 17.4z" _stroke="#000" stroke-width="1.2"/><path pid="2" d="M7.512 41.4H6.016C8.633 36.425 9.928 30.199 9.928 24c0-6.199-1.295-12.425-3.912-17.4h1.496c8.517 9.718 8.517 25.082 0 34.8z" _stroke="#000" stroke-width="1.2"/>`,
    },
});
